<template>
  <div id="app">
    <v-header v-if="$route.path !== '/checkout'"></v-header>
    <router-view></router-view>
    <v-footer :Visits2="Visits2" v-if="$route.path !== '/checkout'"></v-footer>
  </div>
</template>

<script>
// import vueEvent from '../../model/vueEvent.js'
import footer from "./components/public/footer.vue";
import header from "./components/public/header.vue";

export default {
  components: {
    "v-header": header,
    "v-footer": footer,
  },
  name: "app",
  data() {
    return {
      Visits2: 0,
    };
  },
  methods: {
    //用户访问量
    GetSiteAccessCount() {
      var that = this;
      that.$httphelper
        .GetSiteAccessCount({
          journalId: that.$_JournalId,
        })
        .then((res) => {
          if (res.code == 200) {
            that.Visits2 = res.data || "";
            console.log(that.Visits2, "that.Visits!!!!!!!!!");
            that.$loading.hideLoading();
          } else {
          }
        });

      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isOpera = userAgent.indexOf("Opera") > -1;
      if (isOpera) {
        //判断是否Opera浏览器
        return "Opera";
      }
      if (userAgent.indexOf("Firefox") > -1) {
        //判断是否Firefox浏览器
        return "FF";
      }
      if (userAgent.indexOf("Chrome") > -1) {
        //判断是否Chrome浏览器
        return "Chrome";
      }
      if (userAgent.indexOf("Safari") > -1) {
        //判断是否Safari浏览器
        return "Safari";
      }
      if (
        userAgent.indexOf("compatible") > -1 &&
        userAgent.indexOf("MSIE") > -1 &&
        !isOpera
      ) {
        //判断是否IE浏览器
        return "IE";
      }
    },
  },
  created() {
    this.GetSiteAccessCount();
  },
};
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
  min-width: 1366px;
  background-color: #f5f6f8;
}
#app {
  min-width: 1366px;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue